import React from 'react';
import ContentHeader from 'src/app/layouts/content/ContentHeader';
import useUserList from '../hooks/useUserList';
import UserListToolbar from '../components/UserListToolbar';
import UserPagination from '../components/UserPagination';
import UserTable from '../components/UserTable';

export default function UserListPage() {
  const users = useUserList();

  const toggleSort = () => users.setSortDirection(users.sort.direction === 'asc' ? 'desc' : 'asc');

  return (
    <div className="container-fluid h-100 d-flex flex-column">
      <ContentHeader title="Users" showSearch={false}>
        <UserListToolbar filter={users.filter} onFilterChange={users.setFilter} />
      </ContentHeader>
      <div className="d-flex gap-2 py-2 flex-wrap">
        {['invited', 'registered'].map((status) => (
          <label key={status} className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              checked={users.status.includes(status)}
              disabled={users.status.length === 1 && users.status.includes(status)}
              onChange={(event) => users.setStatus(
                event.target.checked
                  ? [...users.status, status]
                  : users.status.filter((value) => value !== status)
              )}
            />
            <span className="form-check-label">{status}</span>
          </label>
        ))}
      </div>
      <UserTable users={users.items} loading={users.loading} direction={users.sort.direction} onToggleSort={toggleSort} />
      <UserPagination hasPrevious={users.hasPrevious} hasNext={!!users.nextCursor} onPrevious={users.previous} onNext={users.next} />
    </div>
  );
}
